/* eslint-disable @typescript-eslint/no-explicit-any */
import { Select } from 'antd';
import { MergedProperty } from '../../types';

interface SelectBoxItemProps {
    item: MergedProperty;
    colClass: string;
    value: any;
    listSelect: any[];
    idField: string;
    nameField: string;
    onChange: (value: any, code: string) => void;
}

const SelectBoxItem = ({
    item,
    colClass,
    value,
    listSelect,
    idField,
    nameField,
    onChange,
}: SelectBoxItemProps) => (
    <div className={`${colClass} col-sm-6`}>
        <div className="form-group">
            <label>
                <h6 className="panel-title">{item.p_name}</h6>
            </label>
            <Select
                value={+value || null}
                onChange={(val) => onChange(val, item.ps_code)}
                placeholder="Vui lòng chọn"
            >
                {listSelect.map((elm) => (
                    <Select.Option value={elm[idField]} key={elm[idField]}>
                        {elm[nameField]}
                    </Select.Option>
                ))}
            </Select>
            <div className="contain-error" />
        </div>
    </div>
);

export default SelectBoxItem;
